import { Component, Inject, Injector, OnInit } from '@angular/core';
import {
  FormControl,
  FormGroup,
  UntypedFormBuilder,
  Validators,
} from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import {
  ModuleName,
  Modules,
  NotificationHeader,
  NotificationTextMessage,
} from '@app/core/Enum';
import { GlobalComponent, MainListParameters } from '@app/core/Models';
import { CommonService, NotificationService } from '@app/core/Services';
import {
  CountryState,
  GetCountryList,
  GetDataByCompanyId,
  SendVatEmail,
  ShareFile,
} from '@app/core/Store';
import { EmailTemplatesComponent } from '@app/modules/email-templates';
import { Store } from '@ngxs/store';
import { NgxSpinnerService } from 'ngx-spinner';
import { tap } from 'rxjs/operators';

@Component({
  selector: 'app-share',
  templateUrl: './share.component.html',
  styleUrls: ['./share.component.scss'],
})
export class ShareComponent implements OnInit {
  emailForm: FormGroup;
  fileId: string;
  item: any;
  breadcrumbs: any = [];
  sendMailParamsRequest: MainListParameters = new MainListParameters();

  spinner: NgxSpinnerService;
  isFormSubmitted = false;
  isShowLoader = false;
  moduleId: number;
  constructor(
    private formBuilder: UntypedFormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<EmailTemplatesComponent>,
    public store: Store,
    private notifier: NotificationService,
    public commonService: CommonService,
    private globalComponent: GlobalComponent,
    private injector: Injector
  ) {
    this.spinner = injector.get<NgxSpinnerService>(NgxSpinnerService);
  }
  companyId: any;
  countryList: any = [];
  ngOnInit(): void {
    this.GetCountryListData();
    this.emailForm = this.formBuilder.group({
      to: new FormControl('', [Validators.required, Validators.email]),
      cc: new FormControl(''),
      bcc: new FormControl(''),
      message: new FormControl('', Validators.required),
      subject: new FormControl('', Validators.required),
    });
    this.companyId = this.globalComponent.getCompanyId();
    setTimeout(() => {
      this.setMailTemplateDetails();
    }, 500);
  }
  setMailTemplateDetails(): void {
    this.store
      .dispatch(new GetDataByCompanyId(this.companyId))
      .subscribe((res) => {
        this.sendMailParamsRequest = this.data.sendMailParamsRequest;
        this.moduleId = this.data.moduleId;
        const subjectName = this.getModuleName(this.moduleId);
        const companyData = res.company.companyData;
        const countryDetails = this.countryList.filter(
          (x) => x.id == companyData?.addressDetail?.country
        );
        {
          this.emailForm.patchValue({
            subject: subjectName,
            message:
              '<p>Dear,</p><br><p>Please find attached the following ' +
              subjectName +
              '</p><p>Should you have any queries, please do not hesitate to contact us on the details below.</p><br> <p>Regards,</p><p>' +
              companyData.name +
              '</p> <p>' +
              companyData?.addressDetail?.address1 +
              '</p> <p>' +
              countryDetails[0]?.description +
              '</p><p>' +
              companyData?.addressDetail?.postalCode +
              '</p>',
          });
        }
      });
  }
  GetCountryListData(): void {
    this.store
      .dispatch(new GetCountryList())
      .pipe(
        tap(() => {
          this.countryList = this.store.selectSnapshot(CountryState.getCountry);
        })
      )
      .subscribe();
  }

  getModuleName(moduleId: number): any {
    switch (moduleId) {
      case Modules.AccountProductionBalanceSheet:
      case Modules.BalanceSheet:
        return 'Balance Sheet Report';
      case Modules.StatementofFinancialActivities:
      case Modules.AccountProductionStatementofFinancialActivities:
        return 'Statement of Financial Activities Report';
      case Modules.ReceiptAndPayment:
      case Modules.AccountProductionReceiptAndPayment:
        return 'Receipt And Payment Report';
      case Modules.StatementOfAssetsAndLiabilities:
      case Modules.AccountProductionStatementOfAssetsAndLiabilities:
        return 'Statement Of Assets And Liabilities Report';
      case Modules.TrialBalance:
      case Modules.AccountProductionTrialBalance:
        return 'Trial Balance Report';
      case Modules.SalesDayBook:
        return 'Sales Day Book Report';
      case Modules.PurchaseDayBook:
        return 'Purchase Day Book Report';
      case Modules.IncomeAndExpenditure:
        return 'Income And Expenditure Account Report';
      case Modules.AccountDetails:
        return 'Account Details Report';
      case Modules.NominalLedger:
        return 'Nominal Ledger Report';
      case Modules.CustomerAdvanceReport:
        return 'Customer Advance Report';
      case Modules.SalesReport:
        return 'Sales Report';
      case Modules.CustomerList:
        return 'Customer List Report';
      case Modules.CustomerAgeingList:
        return 'Customer Ageing List Report';
      case Modules.TransactionsByCustomer:
        return 'Transactions By Customer Report';
      case Modules.CustomerReceipts:
        return 'Customer Receipts Report';
      case Modules.Debtors:
        return 'Debtors Report';
      case Modules.CustomerStatement:
        return 'Customer Statement Report';
      case Modules.SupplierAdvanceReport:
        return 'Supplier Advance Report';
      case Modules.PurchasesReport:
        return 'Purchases Report';
      case Modules.SupplierList:
        return 'Supplier List Report';
      case Modules.SupplierAgeingList:
        return 'Supplier Ageing List Report';
      case Modules.TransactionsBySupplier:
        return 'Transactions By Supplier Report';
      case Modules.PaymentToSupplier:
        return 'Payment To Supplier Report';
      case Modules.Creditors:
        return 'Creditors Report';
      case Modules.SupplierStatement:
        return 'Supplier Statement Report';
      case Modules.VAT:
        return 'VAT Report';
      case Modules.InvoiceList:
        return 'Invoice List Report';
      case Modules.BillList:
        return 'Bill List Report';
      case Modules.DonorReport:
        return ModuleName.DonorReport;
      case Modules.SubmitVat:
      case Modules.BridgingVAT:
        return 'VAT Return';

      default:
        return 'Report';
    }
  }
  hideOrShowBCC = false;
  hideOrShowCC = false;
  HideorShowCC(): void {
    this.hideOrShowCC = true;
  }

  HideorShowBCC(): void {
    this.hideOrShowBCC = true;
  }

  get getFormControls(): any {
    return this.emailForm.controls;
  }

  onSend(): void {
    this.isFormSubmitted = true;
    const message = this.emailForm.controls.message.value;
    if (this.emailForm.invalid) {
      return;
    }

    this.isFormSubmitted = false;
    const toMailId = this.emailForm.controls.to.value;
    const ccMailId = this.emailForm.controls.cc.value;
    const bccMailId = this.emailForm.controls.bcc.value;
    const subject = this.emailForm.controls.subject.value;
    if (
      this.moduleId === Modules.BridgingVAT ||
      this.moduleId === Modules.SubmitVat
    ) {
      this.spinner.show();
      this.store
        .dispatch(
          new SendVatEmail(
            this.sendMailParamsRequest,
            toMailId,
            ccMailId,
            bccMailId,
            message,
            subject
          )
        )
        .pipe()
        .subscribe((res) => {
          if(res?.submitVat?.isSuccess){
            this.notifier.success(
              NotificationHeader.success,
              NotificationTextMessage.mailSentSuccessfully
            );
          }else{
            this.notifier.error(
              NotificationHeader.error,
              res?.submitVat?.message
            );
          }
          this.dialogRef.close(NotificationHeader.success);
        });
    } else {
      this.store
        .dispatch(
          new ShareFile(
            this.moduleId,
            this.sendMailParamsRequest,
            toMailId,
            ccMailId,
            bccMailId,
            message,
            subject
          )
        )
        .pipe()
        .subscribe((res) => {
          if(res?.common?.isSuccess){
            this.notifier.success(
              NotificationHeader.success,
              NotificationTextMessage.mailSentSuccessfully
            );
          }else{
            this.notifier.error(
              NotificationHeader.error,
              res?.common?.message
            );
          }
          this.dialogRef.close(NotificationHeader.success);
        });
    }
  }
}
